
import { Component, Vue, Watch } from 'vue-property-decorator';
import { ChurnChurnedPredictedModel } from '@/models/churn_churned_predicted';

@Component({})
export default class ChurnChurnedPredicted extends Vue {
    public model: ChurnChurnedPredictedModel = new ChurnChurnedPredictedModel();
    public isLoading: boolean = false;
    public error: string = '';
    public targetDate: string = '';

    public tableOptions: any = {
        page: 1,
        itemsPerPage: 50,
    };

    public headers = [
        { text: 'Store', value: 'store_id', sortable: false, width: '8%' },
        { text: 'Installed At', value: 'installed_at', sortable: false, width: '12%' },
        { text: 'First Predicted', value: 'first_predicted', sortable: false, width: '12%' },
        { text: 'Times Predicted', value: 'times_predicted', sortable: false, width: '10%' },
        { text: 'Last Predicted', value: 'last_predicted', sortable: false, width: '12%' },
        { text: 'Last Risk Tier', value: 'last_risk_tier', sortable: false, width: '12%' },
        { text: 'Last Probability', value: 'last_churn_probability', sortable: false, width: '18%' },
        { text: 'Uninstalled', value: 'uninstalled_at', sortable: false, width: '12%' },
    ];

    public tierColors: Record<string, string> = {
        critical: '#DC2626',
        high: '#F59E0B',
        medium: '#3B82F6',
        low: '#10B981',
    };

    public tierLabels: Record<string, string> = {
        critical: 'Critical',
        high: 'High',
        medium: 'Medium',
        low: 'Low',
    };

    public created(): void {
        const dateParam = this.$route.query.date as string;
        if (dateParam) {
            this.targetDate = dateParam;
        } else {
            // Default to yesterday
            const yesterday = new Date(Date.now() - 86400000);
            this.targetDate = yesterday.toISOString().slice(0, 10);
        }
    }

    public mounted(): void {
        this.fetchMerchants();
    }

    public onDateChange(): void {
        this.tableOptions.page = 1;
        this.fetchMerchants();
    }

    @Watch('tableOptions', { deep: true })
    public onTableOptionsChange(): void {
        this.fetchMerchants();
    }

    public async fetchMerchants(): Promise<void> {
        this.isLoading = true;
        this.error = '';
        try {
            const offset = (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage;
            await this.model.fetch({
                date: this.targetDate || undefined,
                limit: this.tableOptions.itemsPerPage,
                offset,
            });
        } catch (err: any) {
            this.error = err.message || 'Failed to load churned predicted merchants';
        } finally {
            this.isLoading = false;
        }
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '—';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    }

    public getTierIcon(tier: string): string {
        const icons: Record<string, string> = {
            critical: 'mdi-alert-octagon',
            high: 'mdi-alert-circle',
            medium: 'mdi-alert',
            low: 'mdi-check-circle',
        };
        return icons[tier] || 'mdi-help-circle';
    }

    public getProgressColor(probability: number): string {
        if (probability >= 80) return '#DC2626';
        if (probability >= 60) return '#F59E0B';
        if (probability >= 40) return '#3B82F6';
        return '#10B981';
    }
}
